import axios from "api/axiosInstance";
import { AIReviewEvaluation } from "types/aiReviewTest";

interface ApiResponse<T> {
  error: number;
  data: T;
}

interface EvaluationListParams {
  experimentId?: number;
  patientId?: number;
  status?: string;
  limit?: number;
  offset?: number;
  withPatientId?: boolean; // Patient ID 포함 여부
}

export const evaluationApi = {
  // 평가 목록 조회
  findAll: (params?: EvaluationListParams) =>
    axios.get<ApiResponse<AIReviewEvaluation[]>>("/api/v1/admin/ai-review-evaluation/evaluations", {
      params,
    }),

  // 평가 상세 조회
  findOne: (id: number) =>
    axios.get<ApiResponse<AIReviewEvaluation>>(`/api/v1/admin/ai-review-evaluation/evaluations/${id}`),

  // 재평가 실행
  reEvaluate: (id: number) =>
    axios.put<ApiResponse<any>>(`/api/v1/admin/ai-review-evaluation/evaluations/${id}/re-evaluate`, {}, {
      timeout: 600000 // 10분 timeout
    }),
};